<script setup lang="ts">
/**
 * A page-sized placeholder for a view that has to wait for data before it can render.
 *
 * Those views used to render nothing (and then slide in for 750ms), so on a public route the
 * footer filled the screen and was pushed off it when the content arrived. The min-height keeps the
 * space reserved; the status role and its label tell a screen reader something is still loading.
 */
withDefaults( defineProps< {
  label?: string;
  lines?: number;
} >(), {
  label: 'Loading…',
  lines: 10
} );
</script>

<template>
  <div role="status" class="min-h-[60vh]" data-testid="content-skeleton">
    <span class="sr-only">{{ label }}</span>
    <div aria-hidden="true">
      <div class="skeleton h-9 w-2/3"></div>
      <div class="skeleton mt-3 h-4 w-40"></div>
      <div class="mt-8 space-y-3">
        <div v-for="n in lines" :key="n" class="skeleton h-4" :class="n % 4 === 0 ? 'w-3/4' : 'w-full'"></div>
      </div>
    </div>
  </div>
</template>
